import { render, staticRenderFns } from "./Expire.vue?vue&type=template&id=20a4466e&"
import script from "./Expire.vue?vue&type=script&lang=js&"
export * from "./Expire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports